import { Loading } from "@components";
import { useRef, useState } from "react";
import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStepOld.module.scss";
import { Button } from "../../../components/Button";
import { Label } from "../../../components/Label";
import { If } from "../../../components/control-statements";
import { Picture } from "shared/components/Icons";
import classNames from "classnames/bind";
import { AssetsAPI } from "providers/AssetsAPI";

const css = classNames.bind(styles);

const Dimension = {
  width: 500,
  height: 300,
};

export const BenefitImageOld = ({ image, onChange }) => {
  const [loading, setLoading] = useState(false);
  const uploadInputRef = useRef();

  const validateImageSize = async (file, width, height) => {
    if (!file) {
      throw new Error("Arquivo inválido.");
    }

    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const widthImage = img.naturalWidth;
        const heightImage = img.naturalHeight;

        if (widthImage !== width || heightImage !== height) {
          setLoading(false);
          reject(new Error(`A imagem deve ter a dimensão ${width}x${height}`));
        }
        resolve(file);
      };
    });
  };

  const handleSetImage = async (e) => {
    const file = e.target.files[0];
    setLoading(true);

    try {
      const res = await validateImageSize(
        file,
        Dimension.width,
        Dimension.height,
      );
      const uri = await sendFile(res);

      onChange(uri);
    } catch (err) {
      alert({ text: err.message });
    }
  };

  const sendFile = async (file) => {
    const maxFileSize = 1500;
    const fileSize = file.size / 1024;
    const fileType = file.type;

    if (fileSize > maxFileSize) {
      setLoading(false);
      alert({ text: `Escolha um arquivo com no máximo ${maxFileSize} KB.` });
      return false;
    }

    const pattern = /^(image\/(png|jpeg|svg\+xml))$/i;

    if (!fileType.match(pattern)) {
      setLoading(false);
      alert({
        text: "Arquivo inválido. Utilize algum dos seguintes formatos: .png, .jpg, .jpeg, .svg",
      });
      return false;
    }

    return await new Promise((resolve) => {
      let reader = new FileReader();
      reader.onload = async (readerEvent) => {
        const response = await AssetsAPI.PostAssets({
          mime_type: fileType,
          file: readerEvent.target.result.split("base64,")[1],
        });
        resolve(response.getData(null));
        setLoading(false);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <div className={styles.imageContainer}>
      <Label text={"Selecione a imagem do benefício"} />
      <label
        htmlFor="upload"
        className={css({
          uploadBanner: true,
          hasImage: !!image,
          uploading: loading,
        })}
      >
        <If cond={loading}>
          <Loading />
        </If>
        <If cond={!loading}>
          <If cond={image}>
            <img
              src={`${process.env.REACT_APP_ASSETS_URL}/${image}`}
              class="w-100"
            />
          </If>
          <If cond={!image}>
            <div className={styles.icon}>
              <Picture />
            </div>
            <div className={styles.selectFile}>
              <p>Selecione o arquivo</p>
              <span>&nbsp;para fazer upload</span>
            </div>
            <span className={styles.fileAccepted}>
              JPG, JPEG, PNG, SVG ({Dimension.width}x{Dimension.height})
            </span>
            <span className={styles.maxSize}>
              Peso máximo do arquivo: 1,5MB
            </span>
          </If>
          <input
            ref={uploadInputRef}
            type="file"
            id="upload"
            accept=".png, .jpeg, .jpg, .svg"
            onChange={(e) => handleSetImage(e)}
          />
        </If>
        <div className={styles.edit}>
          <Button onClick={() => uploadInputRef.current.click()}>
            Alterar imagem
          </Button>
        </div>
      </label>
    </div>
  );
};
